// extracted by mini-css-extract-plugin
export default {"button":"styles_button__LbyCo","text":"styles_text__+1dyj"};